import React, { useRef, useMemo, useEffect, forwardRef } from 'react';
import cx from 'classnames';
import './PageTransition.css';
import cn from './PageTransition.css.json';
export const PageTransition = forwardRef(function PageTransition({ children, onTransitionComplete, transitioning, fadeTransition }, ref) {
    const classNameRef = useRef(undefined);
    const divRef = useRef(null);
    const transitionRef = useRef(onTransitionComplete);
    transitionRef.current = onTransitionComplete;
    useMemo(() => {
        classNameRef.current = transitioning ? cn.containerStart : undefined;
    }, [transitioning]);
    // TODO: should probably be use-memo-one
    useEffect(() => {
        if (!divRef.current || !transitioning) {
            return;
        }
        // Using fade transition requires a longer transition time
        const timeoutId = setTimeout(() => transitionRef.current(), fadeTransition ? 600 : 100);
        divRef.current.classList.add(cn.containerAnimate);
        if (fadeTransition) {
            divRef.current.classList.add(cn.fade);
        }
        divRef.current.classList.add(cn.containerFinal);
        //TODO: add animationend.
        classNameRef.current = divRef.current.classList.value;
        return () => clearTimeout(timeoutId);
    }, [transitioning, fadeTransition]);
    return (React.createElement("div", { className: cn.base, ref: ref },
        React.createElement("div", { className: cx(cn.container, classNameRef.current), ref: divRef }, children)));
});
